function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1032",
  "data-name": "Rect\\xE1ngulo 1032",
  width: 726.515,
  height: 18.182,
  rx: 7.679,
  transform: "translate(1270.093 794.358)",
  fill: "#71843c"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_103",
  "data-name": "L\\xEDnea 103",
  y1: 320.756,
  transform: "translate(1339.95 467.036)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 10.255
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_415",
  "data-name": "Trazado 415",
  d: "M1430.786,509.994c7.217,4.039,10.86,12.832,10.515,21.1s-4.083,16.036-8.7,22.9a91.033,91.033,0,0,1-26.538,25.909c9.09-4.638,20.95-2.116,28.2,5.066s9.968,18.261,8.039,28.282c-3.792,19.7-23.856,33.1-43.822,35.095s-39.692-5.048-57.982-13.3c-16.568,10.07-36.3,16.062-55.453,13.074s-37.271-16.167-42.789-34.753c-2.778-9.358-2.118-20.1,3.5-28.082s16.73-12.272,25.728-8.486c-5.886-4.527-11.817-9.314-15.6-15.7s-5.036-14.789-1.278-21.193,13.411-9.2,19.041-4.361c-4.358-7.87-8.787-15.94-10.236-24.819s.642-18.877,7.518-24.679c12.194-10.289,31.05-2.453,43.132,7.968-8.027-20.283-15.87-44.042-4.924-62.911,11.33-19.531,42.6-23.014,57.949-6.454,14.739,15.9,12.448,40.624,9.22,62.063a12,12,0,0,1,.516-10.8c4.063-7.039,14.957-7.773,21.3-2.7s8.468,14.063,7.359,22.115-4.931,15.44-8.693,22.645C1406.485,510.282,1419.993,503.953,1430.786,509.994Z",
  fill: "#b2ce74"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_417",
  "data-name": "Trazado 417",
  d: "M1382.229,680.334c-8.532-2.212-17.777,2.7-22.651,10.049s-6.053,16.575-5.644,25.38c-1.24-9.007-14.39-12.5-21.39-6.7s-7.5,16.982-3.137,24.961c-8.035-6.548-20.818-5.836-28.556,1.061s-10.039,18.943-6.057,28.513,13.655,16.3,23.952,17.48c-6.838-.131-13.917-.217-20.2,2.481s-11.571,8.992-10.832,15.791q53.572-2.325,107.22-.99c6.143-26.527,2.444-54.222-1.28-81.195q-1.935-14.009-3.869-28.018a13.419,13.419,0,0,0-1.05-4.193C1387.51,682.5,1384.885,681.023,1382.229,680.334Z",
  fill: "#71843c"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1033",
  "data-name": "Rect\\xE1ngulo 1033",
  width: 332.828,
  height: 190.656,
  transform: "translate(1575.649 605.217)",
  fill: "#e0c6ad"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_420",
  "data-name": "Trazado 420",
  d: "M1546.861,575.167h348.99l35.858,43.939H1599.891S1546.1,575.924,1546.861,575.167Z",
  fill: "#383431"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_422",
  "data-name": "Trazado 422",
  d: "M1377.132,604.459l110.1-75.758,96.465,75.758V795.873H1377.132Z",
  fill: "#f8e3cd"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1034",
  "data-name": "Rect\\xE1ngulo 1034",
  width: 62.879,
  height: 127.904,
  transform: "translate(1448.976 660.899)",
  fill: "#634735",
  stroke: "#2d221b",
  strokeMiterlimit: 10,
  strokeWidth: 4.545
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_424",
  "data-name": "Trazado 424",
  d: "M1362.359,621.284l.537-11.775,122.167-87.487L1603.9,614l-5.563,7.188L1484.858,533.36Z",
  fill: "#e8e8e8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_425",
  "data-name": "Trazado 425",
  d: "M1935.964,624.156l-337.589-2.777,1.553-9.091,336.111,2.777Z",
  fill: "#e8e8e8"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1035",
  "data-name": "Rect\\xE1ngulo 1035",
  width: 85.353,
  height: 10.101,
  transform: "translate(1437.738 785.773)",
  fill: "#aaa8a7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_428",
  "data-name": "Trazado 428",
  d: "M1465.216,717.575h-1.562a.7.7,0,0,0-.077.016h-7.12v.006a2.144,2.144,0,1,0,2.209,2.14c0-.043-.01-.083-.012-.126h5.884v-.047h.678a.995.995,0,1,0,0-1.989Z",
  fill: "#97a3bf"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1038",
  "data-name": "Rect\\xE1ngulo 1038",
  width: 75.979,
  height: 96.045,
  transform: "translate(1622.788 650.861)",
  fill: "#e8e8e8"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1039",
  "data-name": "Rect\\xE1ngulo 1039",
  width: 64.646,
  height: 83.838,
  transform: "translate(1628.454 656.627)",
  fill: "#6f95a5"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_429",
  "data-name": "Trazado 429",
  d: "M1652.872,683.883c-7.574,5.7-15.665,11.554-24.418,14.815v41.767h11.606a251.068,251.068,0,0,1,53.041-66.951V656.627H1682.9C1674.748,667.333,1663.7,675.737,1652.872,683.883Z",
  fill: "#fff",
  opacity: 0.29
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1040",
  "data-name": "Rect\\xE1ngulo 1040",
  width: 8.712,
  height: 86.364,
  transform: "translate(1656.421 655.406)",
  fill: "#e8e8e8"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1041",
  "data-name": "Rect\\xE1ngulo 1041",
  width: 0.505,
  height: 96.591,
  transform: "translate(1660.525 650.672)",
  fill: "#bababa"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1042",
  "data-name": "Rect\\xE1ngulo 1042",
  width: 75.979,
  height: 96.045,
  transform: "translate(1725.061 650.861)",
  fill: "#e8e8e8"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1043",
  "data-name": "Rect\\xE1ngulo 1043",
  width: 64.647,
  height: 83.838,
  transform: "translate(1730.727 656.627)",
  fill: "#6f95a5"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_431",
  "data-name": "Trazado 431",
  d: "M1755.145,683.883c-7.574,5.7-15.666,11.554-24.418,14.815v41.767h11.6a251.108,251.108,0,0,1,53.041-66.951V656.627h-10.206C1777.021,667.333,1765.975,675.737,1755.145,683.883Z",
  fill: "#fff",
  opacity: 0.29
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1044",
  "data-name": "Rect\\xE1ngulo 1044",
  width: 8.712,
  height: 86.364,
  transform: "translate(1758.694 655.406)",
  fill: "#e8e8e8"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1045",
  "data-name": "Rect\\xE1ngulo 1045",
  width: 0.505,
  height: 96.591,
  transform: "translate(1762.797 650.672)",
  fill: "#bababa"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1046",
  "data-name": "Rect\\xE1ngulo 1046",
  width: 77.273,
  height: 31.629,
  transform: "translate(1820.282 652.376)",
  fill: "#e8e8e8"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1047",
  "data-name": "Rect\\xE1ngulo 1047",
  width: 70.454,
  height: 24.621,
  transform: "translate(1823.502 655.974)",
  fill: "#6f95a5"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_433",
  "data-name": "Trazado 433",
  d: "M1870.9,655.975c-.577.912-1.165,1.816-1.8,2.686a37.976,37.976,0,0,1-17.868,13.041,56.335,56.335,0,0,1-22.106,2.954c-1.932-.1-3.883-.264-5.817-.259v6.2h24.438c6.083-2.852,12.093-5.9,17.408-9.982,5.648-4.343,10.483-9.835,16.779-13.171a34.532,34.532,0,0,1,3.217-1.468Z",
  fill: "#fff",
  opacity: 0.29
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1048",
  "data-name": "Rect\\xE1ngulo 1048",
  width: 3.409,
  height: 27.02,
  transform: "translate(1840.926 654.712)",
  fill: "#e8e8e8"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1049",
  "data-name": "Rect\\xE1ngulo 1049",
  width: 3.409,
  height: 27.02,
  transform: "translate(1873.407 654.712)",
  fill: "#e8e8e8"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1050",
  "data-name": "Rect\\xE1ngulo 1050",
  width: 77.273,
  height: 31.629,
  transform: "translate(1440.484 602.881)",
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1051",
  "data-name": "Rect\\xE1ngulo 1051",
  width: 70.455,
  height: 24.621,
  transform: "translate(1443.704 606.48)",
  fill: "#6f95a5"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_435",
  "data-name": "Trazado 435",
  d: "M1491.1,606.48c-.577.912-1.165,1.816-1.794,2.686a37.984,37.984,0,0,1-17.869,13.041,56.313,56.313,0,0,1-22.106,2.954c-1.932-.1-3.883-.264-5.817-.259v6.2h24.438c6.083-2.852,12.093-5.9,17.408-9.982,5.648-4.343,10.483-9.835,16.779-13.171a34.517,34.517,0,0,1,3.217-1.468Z",
  fill: "#fff",
  opacity: 0.29
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1052",
  "data-name": "Rect\\xE1ngulo 1052",
  width: 3.409,
  height: 27.02,
  transform: "translate(1461.129 605.217)",
  fill: "#fff"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  id: "Rect\\xE1ngulo_1053",
  "data-name": "Rect\\xE1ngulo 1053",
  width: 3.409,
  height: 27.02,
  transform: "translate(1493.609 605.217)",
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_334",
  "data-name": "Grupo 334"
}, /*#__PURE__*/React.createElement("line", {
  id: "L\\xEDnea_104",
  "data-name": "L\\xEDnea 104",
  y1: 33.308,
  transform: "translate(1902.242 764.081)",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 2.512
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_437",
  "data-name": "Trazado 437",
  d: "M1929.988,766.771s-3.179,13.035-27.168,14.4",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 2.512
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_438",
  "data-name": "Trazado 438",
  d: "M1947.907,772.531s-3.468,7.275-31.5,6.063",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 2.512
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_439",
  "data-name": "Trazado 439",
  d: "M1901.664,784.427s-35.333.454-40.536-12.619",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 2.512
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_440",
  "data-name": "Trazado 440",
  d: "M1884.756,771.126a13.461,13.461,0,0,1-10.188,9.322",
  fill: "none",
  stroke: "#634735",
  strokeMiterlimit: 10,
  strokeWidth: 2.512
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_441",
  "data-name": "Trazado 441",
  d: "M1791.878,782.383c.437,3.885,5.2,5.388,9.063,6l6.624,1.056a33.672,33.672,0,0,0,7.108.62,17.024,17.024,0,0,0,12.311-6.434c-1.456,1.513.794,3.751,2.746,4.523,7.722,3.052,16.378,4.493,24.363,2.218s15.053-8.834,16.267-17.048a17.932,17.932,0,0,0,28.685-12.227c1.818,7.914,9.078,13.986,17.075,15.4s16.4-1.443,22.655-6.622a16.046,16.046,0,0,0,28.348,6.946,16.684,16.684,0,0,0,13.5,10.9c4.584.545,9.778-1.324,11.724-5.511s-1.154-10.237-5.763-9.969c3.789-2.4,4.526-8.255,1.824-11.835s-8.055-4.615-12.147-2.78a10.933,10.933,0,0,0-12.413-16.76c1.274-2.83,2.568-5.735,2.78-8.831s-.878-6.474-3.482-8.163c-2.023-1.313-4.589-1.414-7-1.259a41.05,41.05,0,0,0-10.006,1.908c1.692-4.609,1.807-10.152-1.148-14.072s-9.543-5.058-12.8-1.383c2.44-8.272-3.727-17.394-11.89-20.177s-17.366-.332-24.635,4.31c-3.927,2.507-7.551,5.759-9.5,9.991s-1.938,9.571.9,13.27c-2.139-.707-3.8-2.458-5.931-3.2-3.9-1.369-8.316,1.132-10.495,4.648s-2.659,7.789-3.087,11.9c-7.539-5.526-18.869-3.655-25.726,2.7s-9.706,16.132-9.621,25.48c-5.693-3.768-13.8-2.735-19.032,1.657s-7.659,11.561-7.219,18.374c-2.757-1.155-5.73-2.2-8.676-1.7S1791.543,779.413,1791.878,782.383Z",
  fill: "#b2ce74"
});

var SvgHouse2 = function SvgHouse2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755.942,
    height: 398.458,
    viewBox: "0 0 755.942 398.458",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    transform: "translate(-1240.666 -414.083)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326"
  }, _ref3, _ref4, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M1432.6,553.992c4.613-6.867,8.351-14.638,8.7-22.9s-3.3-17.057-10.515-21.1c-10.792-6.041-24.3.289-33.989,7.977,3.762-7.2,7.584-14.592,8.693-22.644s-1.011-17.038-7.359-22.115c-5.848-4.676-15.54-4.407-20.209,1.164,1.876-18.072,1.142-36.814-10.832-49.731a30.548,30.548,0,0,0-4.341-3.852c5.98,9.8,11.226,20.2,11.432,31.533.248,13.72-10.192,28.6-23.889,27.764,10.771,9.643,8.926,29.681-3.424,37.194a20.757,20.757,0,0,1,6.749,38.268c8.756-4.612,19.813-1.125,27.643,4.928,8.25,6.378,14.565,17.562,10.318,27.086-1.619,3.629-4.571,6.505-7.758,8.88-16,11.921-39.806,12.006-55.889.2-3.179,7.556-10.9,12.152-18.545,15.1-13.656,5.272-29.164,6.9-42.941,1.948-10.418-3.742-19.548-11.681-24.106-21.616a35.576,35.576,0,0,0-.078,21.283c5.518,18.586,23.633,31.765,42.789,34.753s38.885-3,55.452-13.074c18.291,8.252,38.017,15.3,57.983,13.3,12.928-1.293,25.869-7.386,34.435-16.854a138.7,138.7,0,0,0,4.889-16.3c1.327-5.3,2.669-10.659,4.212-15.944a29.384,29.384,0,0,0-7.752-14.276c-7.251-7.182-19.11-9.7-28.2-5.066A91.017,91.017,0,0,0,1432.6,553.992Z",
    fill: "#b2ce74",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _ref5, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M1401.5,796.343c6.142-26.527,2.444-54.222-1.281-81.2q-1.529-11.076-3.059-22.153c-9.936.9-19.323,7.71-24.146,16.678-5.943,11.053-5.893,24.527-2.7,36.664a17.888,17.888,0,0,0-16.2,31.181c-9.99,1.887-20.1,4.033-29.072,8.814a43.734,43.734,0,0,0-12.959,10.342Q1356.773,795.243,1401.5,796.343Z",
    fill: "#71843c",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333"
  }, _ref6, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M1575.144,596.884l6.566,117.172,21.717-82.828h305.051v-26.01Z",
    fill: "#e0c6ad",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref7, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M1632.972,594.611l57.222-19.445H1546.861c-.758.758,53.03,43.94,53.03,43.94h27.694l22.054-4.04Z",
    fill: "#383431",
    opacity: 0.32,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref8, _ref9, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M1377.479,605.028,1377.1,623.4l107.576-78.22,98.674,79.735.379-23.106L1486,528.323Z",
    fill: "#f8e3cd",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref10, _ref11, _ref12, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1036",
    "data-name": "Rect\\xE1ngulo 1036",
    width: 46.212,
    height: 42.677,
    transform: "translate(1457.214 669.358)",
    fill: "#634735",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M1459.424,671.568h44v-2.209h-46.212v42.677h2.21Z",
    fill: "#634735",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1037",
    "data-name": "Rect\\xE1ngulo 1037",
    width: 46.212,
    height: 42.677,
    transform: "translate(1457.214 729.712)",
    fill: "#634735",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M1459.424,731.921h44v-2.21h-46.212v42.677h2.21Z",
    fill: "#634735",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _ref13, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329"
  }, _ref14, _ref15, _ref16, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M1628.517,656.627v4.04h61.111v79.8h3.535V656.627Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref17, _ref18), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330"
  }, _ref19, _ref20, _ref21, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_432",
    "data-name": "Trazado 432",
    d: "M1730.79,656.627v4.04H1791.9v79.8h3.535V656.627Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref22, _ref23), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331"
  }, _ref24, _ref25, _ref26, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_434",
    "data-name": "Trazado 434",
    d: "M1823.5,655.974V659h67.614V680.6h2.841V655.974Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref27, _ref28), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332"
  }, _ref29, _ref30, _ref31, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M1443.7,606.48v3.03h67.614V631.1h2.841V606.48Z",
    fill: "#6f95a5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref32, _ref33)), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335"
  }, _ref34, _ref35, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    "data-name": "Trazado 442",
    d: "M1986.584,772.233c3.789-2.4,4.526-8.255,1.824-11.835s-8.055-4.615-12.147-2.78a10.933,10.933,0,0,0-12.413-16.76c1.274-2.829,2.568-5.735,2.78-8.831a11.021,11.021,0,0,0-.15-2.648c-.1.284-.176.574-.289.854-2.21,5.463-7.816,9.9-13.654,9.107,4.47,3.847,4.106,11.929-.692,15.359s-12.563,1.159-14.757-4.316c-3.473,5.049-10.78,6.261-16.568,4.25s-10.322-6.539-14.275-11.222a27.375,27.375,0,0,1-39.63,13.553,22.918,22.918,0,0,1-33.661,15.468c-1.072,5.8-7.79,8.373-13.521,9.757-3.87.935-7.949,1.8-11.784.735-3.127-.867-5.977-3.454-6.6-6.512a10.528,10.528,0,0,0-3.766-.1c-2.947.5-5.739,3.1-5.4,6.072.437,3.885,5.2,5.388,9.063,6l6.624,1.055a33.474,33.474,0,0,0,7.108.62,17.019,17.019,0,0,0,12.311-6.433c-1.456,1.513.794,3.751,2.746,4.523,7.722,3.052,16.378,4.493,24.363,2.218s15.053-8.834,16.267-17.048a17.932,17.932,0,0,0,28.685-12.227c1.818,7.914,9.078,13.986,17.075,15.4s16.4-1.443,22.655-6.622a16.046,16.046,0,0,0,28.349,6.945,16.68,16.68,0,0,0,13.5,10.9c4.584.546,9.778-1.324,11.724-5.511S1991.193,771.965,1986.584,772.233Z",
    fill: "#b2ce74",
    opacity: 0.75,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house2.51de3ee8.svg";
export { ForwardRef as ReactComponent };